import { render } from "./ContactHealthScoreChart.vue?vue&type=template&id=ba7739ba&ts=true"
import script from "./ContactHealthScoreChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactHealthScoreChart.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/contact/components/ContactHealthScoreChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ba7739ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ba7739ba', __exports__)) {
    api.reload('ba7739ba', __exports__)
  }
  
  module.hot.accept("./ContactHealthScoreChart.vue?vue&type=template&id=ba7739ba&ts=true", () => {
    api.rerender('ba7739ba', render)
  })

}


export default __exports__